import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=e82feb7e&scoped=true&"
import script from "./ViewItem.vue?vue&type=script&lang=js&"
export * from "./ViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ViewItem.vue?vue&type=style&index=0&id=e82feb7e&prod&scoped=true&lang=css&"
import style1 from "./ViewItem.vue?vue&type=style&index=1&id=e82feb7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82feb7e",
  null
  
)

export default component.exports